module.exports = __webpack_public_path__ + "static/img/alarm.9f9ef819.gif";